import styled from 'styled-components';

export const Wrapper = styled.div<{
	accent: string;
	color: string;
	transparent: boolean;
	disabled?: boolean;
}>`
	height: 32px;
	display: flex;
	align-items: center;
	border: 1px solid ${({ color }) => color};
	color: ${({ accent }) => accent};
	background-color: ${({ color, transparent }) =>
		transparent ? 'transparent' : color};
	cursor: pointer;
	user-select: none;
	overflow: hidden;
	p {
		height: 100%;
		width: 100%;
		margin: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 8px;
	}
	&:hover {
		${({ disabled, accent, color }) =>
			!disabled &&
			`
			p {
				color: ${color};
				background-color: ${accent};
			}
		`}
	}
	${({ disabled }) =>
		disabled &&
		`
		opacity: 50%;
		cursor: not-allowed;
	`}
	@media screen and (max-width: 550px) {
		width: 85% !important;
	}
`;
